
const $ = (...args) => document.querySelector(...args)
const $$ = (...args) => [...document.querySelectorAll(...args)]


function changeHandler() {
    const selected = $$(`[data-find-your-route-option]:checked`)
    const selectedMap = selected.reduce((prev, current) => {
        prev[current.value] = true;
        return prev;
    }, {})

    const results = $$('[data-find-your-route-conditions]').forEach(el => {
        const attr = el.getAttribute('data-find-your-route-conditions')
        const conditions = attr.split('|').filter(Boolean)
        const selectedKeys = Object.keys(selectedMap)
        const inSelectedMap = conditions.map(condition => !!selectedMap[condition]).filter(Boolean)

        const isMatch = (
            // matches all conditions
            ((conditions.length > 0) && inSelectedMap.length === conditions.length)
            // or if none are selected, and there are no conditions, show
            || (conditions.length === 0 && selectedKeys.length === 0)
        )
        
        if (isMatch) {
            el.style.display = 'block'
        } else {
            el.style.display = 'none'
        }
    })
}

export default () => {
    $$('[data-find-your-route-option]').map(radio => radio.addEventListener('change', changeHandler))
    changeHandler()
}